import type { DatovkaApiType } from '@gov-nx/api';
import { propEq } from '@gov-nx/core/types';
import {
	useDataBoxStoreLists,
	usePersonStore,
	usePersonStoreBusiness,
} from '@gov-nx/store';

const hasDisconnectedDataBox =
	(disconnectedDataBoxes: DatovkaApiType[]) =>
	(type: DatovkaApiType['typSchranky']) =>
		disconnectedDataBoxes.filter(propEq('typSchranky', type)).length > 0;

export const useApplicantSelector = () => {
	const requiredDataBoxes: DatovkaApiType['typSchranky'][] = [
		'FO',
		'PFO',
		'PO',
	];
	const {
		getConnectedDataBoxesByTypes,
		getDataBoxByType,
		disconnectedDataBoxes,
	} = useDataBoxStoreLists();

	const dataBoxes = getConnectedDataBoxesByTypes(requiredDataBoxes);
	const dataBoxFO = getDataBoxByType('FO');
	const individualPerson = usePersonStore('individual');
	const { poBusinessDataPFO, poBusinessDataPO } = usePersonStoreBusiness();
	const hasDisconnectedDS = hasDisconnectedDataBox(disconnectedDataBoxes);

	return {
		dataBoxes,
		dataBoxesPO: poBusinessDataPO,
		dataBoxPFO: poBusinessDataPFO,
		dataBoxFO,
		individualPerson,
		hasDisconnectedDS,
	};
};
